import { ComponentItem } from "designSystem/types/component-item-types";

export var itemSets: ComponentItem[] = null;

export const itemsInChinese: ComponentItem[] = [
	{ id: "1", name: "圣何塞", group: "CA", value: "San Jose" },
	{ id: "2", name: "旧金山", group: "CA", value: "San Francisco" },
	{ id: "3", name: "凤凰城", group: "AZ", value: "Phoenix" },
	{ id: "4", name: "西雅图", group: "WA", value: "Seattle" },
];

export const items: ComponentItem[] = [
	{ id: "1", name: "San Jose", group: "CA", value: "San Jose" },
	{ id: "2", name: "San Francisco", group: "CA", value: "San Francisco" },
	{ id: "3", name: "Phoenix", group: "AZ", value: "Phoenix" },
	{ id: "4", name: "Seattle", group: "WA", value: "Seattle" },
	{ id: "5", name: "Seattle with a long name and text", group: "XX", value: "Seattle with a long name and text" },
	{ id: "6", name: "Scotts Valley", group: "CA", value: "Scotts Valley" },
	{ id: "7", name: "Santa Cruz", group: "CA", value: "Santa Cruz" },
];

// get huge data set, get 500*5 = 2500 for now
export const getItems = (): ComponentItem[] => {
	if (itemSets) {
		return itemSets;
	}
	itemSets = [];

	for (let i = 0; i < 500; i++) {
		itemSets.push(...items.map((item) => ({ id: `${item.id}${i}`, name: `${item.name}${i}`, group: item.group })));
	}

	return itemSets;
};

export const sortedByGroupItems: ComponentItem[] = [
	{ id: "1", name: "Fremont ", group: "CA", value: "Fremont" },
	{ id: "2", name: "Fresno ", group: "CA", value: "Fresno" },
	{ id: "3", name: "Long Beach ", group: "CA", value: "Long Beach" },
	{ id: "4", name: "Los Angeles ", group: "CA", value: "Los Angeles" },
	{ id: "5", name: "Oakland ", group: "CA", value: "Oakland" },
	{ id: "6", name: "Riverside ", group: "CA", value: "Riverside" },
	{ id: "7", name: "Sacramento ", group: "CA", value: "Sacramento" },
	{ id: "8", name: "San Bernardino ", group: "CA", value: "San Bernardino" },
	{ id: "9", name: "San Diego ", group: "CA", value: "San Diego" },
	{ id: "10", name: "San Francisco ", group: "CA", value: "San Francisco" },
	{ id: "11", name: "San Jose ", group: "CA", value: "San Jose" },
	{ id: "12", name: "Santa Ana ", group: "CA", value: "Santa Ana" },
	{ id: "13", name: "Santa Cruz ", group: "CA", value: "Santa Cruz" },
	{ id: "14", name: "Scotts Valley", group: "CA", value: "Scotts Valley" },
	{ id: "15", name: "Bellevue", group: "WA", value: "Bellevue" },
	{ id: "16", name: "Bellingham", group: "WA", value: "Bellingham" },
	{ id: "17", name: "Everett", group: "WA", value: "Everett" },
	{ id: "18", name: "Kent", group: "WA", value: "Kent" },
	{ id: "19", name: "Seattle", group: "WA", value: "Seattle" },
	{ id: "20", name: "Seattle with a long name and text", group: "WA", value: "Seattle with a long name and text" },
	{ id: "21", name: "Spokane", group: "WA", value: "Spokane" },
	{ id: "22", name: "Tacoma", group: "WA", value: "Tacoma" },
	{ id: "23", name: "Yakima", group: "WA", value: "Yakima" },
	{ id: "24", name: "Mesa", group: "AZ", value: "Mesa" },
	{ id: "25", name: "Phoeniz", group: "AZ", value: "Phoeniz" },
	{ id: "26", name: "Tucson", group: "AZ", value: "Tucson" },
	{ id: "27", name: "Carson City", group: "NV", value: "Carson City" },
	{ id: "28", name: "Henderson", group: "NV", value: "Henderson" },
	{ id: "29", name: "Las Vegas", group: "NV", value: "Las Vegas" },
	{ id: "30", name: "Reno", group: "NV", value: "Reno" },
	{ id: "31", name: "Sparks", group: "NV", value: "Sparks" },
	{ id: "32", name: "Spring Valley", group: "NV", value: "Spring Valley" },
	{ id: "33", name: "Sunrise Manor", group: "NV", value: "Sunrise Manor" },
	{ id: "34", name: "Winchester", group: "NV", value: "Winchester" },
];

export const slimCardItems: ComponentItem[] = [
	{ id: "1", name: "San Jose", group: "CA", value: "San Jose", name2: "Large one" },
	{ id: "2", name: "San Francisco", group: "CA", value: "San Francisco", name2: "Foggy" },
	{ id: "6", name: "Scotts Valley", group: "CA", value: "Scotts Valley", name2: "Mountain" },
	{ id: "7", name: "Santa Cruz", group: "CA", value: "Santa Cruz", name2: "Ocean" },
	{ id: "3", name: "Phoenix", group: "AZ", value: "Phoenix", name2: "Fire bird" },
	{ id: "4", name: "Seattle", group: "WA", value: "Seattle", name2: "Microsoft" },
	{ id: "5", name: "Seattle with a long name and text", group: "XX", value: "Seattle with a long name and text", name2: "Microsoft with a long name and text" },
];

